/**
 * Travel Agent Feature - Main Export
 *
 * Provides the AI-powered personal travel assistant feature.
 *
 * Phase 1:
 * - TravelAgentPage: Full-page three-panel layout
 * - travelAgentService: Firestore session/message management + CF calls
 * - initTravelAgentServices: Deferred initialization (safe to call at startup)
 *
 * Phase 2:
 * - agentSuggestionsService: Real-time subscription to agentSuggestions subcollection
 * - proposalExecutionService: Executes approved proposals via entity services
 *
 * Phase 3:
 * - tripReviewService: Proactive trip review on page open (calls tripReview CF)
 *
 * Firestore Structure:
 * users/{userId}/trips/{tripId}/agentSessions/{sessionId}
 *   messages/{messageId}
 * users/{userId}/trips/{tripId}/agentSuggestions/{suggestionId}
 */

import { travelAgentService } from './services/travelAgentService.js';
import { agentSuggestionsService } from './services/agentSuggestionsService.js';
import { proposalExecutionService } from './services/proposalExecutionService.js';
import { tripReviewService } from './services/tripReviewService.js';
import TravelAgentPage from './components/TravelAgentPage/TravelAgentPage.jsx';

/**
 * Initialize travel agent services
 * Follows the deferred init pattern — NEVER called from package index automatically.
 * Called by initAppFeaturesServices in packages/app-features/src/index.js.
 */
export const initTravelAgentServices = () => {
  travelAgentService.init();
  agentSuggestionsService.init();
  console.log('Travel Agent services initialized');
};

/**
 * Main travel agent interface object
 */
export const travelAgent = {
  service: travelAgentService,
  suggestionsService: agentSuggestionsService,
  executionService: proposalExecutionService,
  reviewService: tripReviewService
};

// Named component exports
export { TravelAgentPage };

// Named service exports
export { travelAgentService };
export { agentSuggestionsService } from './services/agentSuggestionsService';
export { proposalExecutionService } from './services/proposalExecutionService';
export { tripReviewService } from './services/tripReviewService';

export default travelAgent;
